import { useEffect, useState } from 'react';

import { readNarratives } from '@api/narratives';
import { HelpIcon, IconButtonV2, Layout } from '@utilities';

import { HELP_CENTER_BASE_URL } from '../../pages/Narratives/utilities/constants';
import Footer from '../../../../components/Footer';
import InteractiveTile from './components/InteractiveTile';
import ModalBuildNarrative from './components/ModalBuildNarrative';
import Page from '../../layouts/Page';

import styles from './_index.module.scss';

const Narratives = () => {
  const [narrativeRoutes, setNarrativeRoutes] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedRoute, setSelectedRoute] = useState({});

  useEffect(() => {
    const fetchNarrativeRoutes = async () => {
      try {
        const response = await readNarratives();

        setNarrativeRoutes(response);
      } catch (error) {
        console.error(error);
      }
    };

    fetchNarrativeRoutes();
  }, []);

  const handleTileClick = (route) => {
    setSelectedRoute(route);
    setIsModalOpen(true);
  };

  return (
    <Page className={styles['narratives-shell']}>
      <Layout.Column className={styles['narratives']}>
        <div className={styles['narratives-content']}>
          <div className={styles['narrative-header']}>
            <h1>Welcome to Numerator Narratives</h1>
            <h2>Discover how to quickly create a data story to support your business objective.</h2>
          </div>
          <div className={styles['interactive-tiles']}>
            {narrativeRoutes.map((route) => (
              <InteractiveTile key={route.id} onClick={handleTileClick} route={route} />
            ))}
          </div>
          {isModalOpen && (
            <ModalBuildNarrative route={selectedRoute} setIsModalOpen={setIsModalOpen} />
          )}
        </div>
        <Footer />
      </Layout.Column>

      <IconButtonV2
        aria-label="Help"
        className={styles['help-button']}
        icon={<HelpIcon />}
        onClick={() => window.open(HELP_CENTER_BASE_URL, '_blank', 'noopener,noreferrer')}
        size="small"
        tooltip="Help"
        tooltipProps={{ placement: 'left' }}
        variant="subtle"
      />
    </Page>
  );
};

export default Narratives;
